module.exports = __webpack_public_path__ + "static/img/zhgjt.9f5ead2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhgjt.png
// module id = LeGo
// module chunks = 0